/* eslint-disable */
import TopicTemplates from "./templates/topics";
import { limits } from "@nualang/nualang-api-and-queries/index.js";
import BotTemplates from "./templates/bots";
import roleplayTemplates from "./templates/roleplay";
import Nualas from "./nualas";
import { resolveVoice as resolveVoiceIn } from "./utils/voices";

const languages = {
  spanish: {
    categoryTypesArray: ["Categories"],
    Voice: "Penelope",
    skipAnswerMessage: ["No te rindas."],
    correctAnswerMessage: [
      "¡Perfecto!",
      "¡Excelente!",
      "¡Genial!",
      "¡Fantástico!",
    ],
    incorrectAnswerMessage: [
      "No exactamente",
      "No te rindas.",
      "Nunca un fracaso, siempre una lección.",
    ],
    partiallyCorrectAnswerMessage: [
      "¡Bien!",
      "¡Muy bien!",
      "¡Buen trabajo!",
      "¡Aprendes rápido!",
    ],
    Voices: {
      "es-US": {
        label: "Spanish, US",
        languageCode: "es-US",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala18,
            name: "Paloma",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala10,
            name: "Alonso",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala3,
            name: "Lupe",
            engine: "neural",
          },
          {
            ...Nualas.nuala5,
            name: "Pedro",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala2,
            name: "Penelope",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala1,
            name: "Miguel",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "es-ES": {
        label: "Spanish, Europe",
        languageCode: "es-ES",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala6,
            name: "Ximena",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala20,
            name: "Elvira",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala19,
            name: "Alvaro",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala9,
            name: "Lucia",
            engine: "neural",
          },
          {
            ...Nualas.nuala15,
            name: "Sergio",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala1,
            name: "Dario",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala4,
            name: "Vera",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala7,
            name: "Conchita",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala4,
            name: "Enrique",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "es-MX": {
        label: "Spanish, Mexico",
        languageCode: "es-MX",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala20,
            name: "Dalia",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala12,
            name: "Jorge",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala11,
            name: "Marina",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
            isChild: true,
          },
          {
            ...Nualas.nuala13,
            name: "Luciano",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala6,
            name: "Mia",
            engine: "neural",
          },
          {
            ...Nualas.nuala8,
            name: "Andres",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala5,
            name: "Carlota",
            engine: "neural",
            provider: "azure",
          },
        ],
      },
    },
    Code: "es",
    Tag: "es-US",
    characters: [
      "¿",
      "¡",
      "á",
      "Á",
      "é",
      "É",
      "í",
      "Í",
      "ó",
      "Ó",
      "ú",
      "Ú",
      "ü",
      "Ü",
      "ñ",
      "Ñ",
    ],
    topicBlueprints: TopicTemplates.spanish,
    roleplayBlueprints: roleplayTemplates.spanish,
    botBlueprints: BotTemplates.spanish,
    fromScratchStarter: `// Aquí están los conceptos básicos para comenzar
    
// Esto es un disparador, indicado por '+'. (debe estar en minúsculas)
+ hola
// Estas son respuestas, indicadas por '-'. (Puedes tener tantos como quieras por disparador)
- Hola
- ¿Hola, qué tal?

// Aquí hay un desencadenador catch all, indicado por un solo comodín '*'.
// Se usará cuando el bot no haya encontrado un disparador coincidente
+ *
- Lo siento, no entiendo.
- ¿Podrías preguntar eso de una manera diferente?`,
    BotTemplate:
      "! versi\u00F3n = 2.0\r\n\r\n+ hola bot\r\n- Hola humanos.\r\n\r\n+ mi nombre es *\r\n- <set nombre=<formal>>Encantado de conocerte, <get nombre>.\r\n\r\n+ (cual es mi nombre|quien soy yo)\r\n- Est\u00E1s <get nombre>, \u00BFverdad?\r\n\r\n+ *\r\n- No tengo una respuesta para eso.\r\n- Intenta preguntar eso de otra manera.",
  },
  english: {
    categoryTypesArray: ["Categories"],
    Voice: "Joanna",
    skipAnswerMessage: ["Don't give up."],
    correctAnswerMessage: ["Perfect!"],
    incorrectAnswerMessage: ["Not Exactly!"],
    partiallyCorrectAnswerMessage: ["Good!"],
    Voices: {
      "en-US": {
        label: "English, US",
        languageCode: "en-US",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala21,
            name: "Ava",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala5,
            name: "Andrew",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala14,
            name: "Jason",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala18,
            name: "Jane",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala9,
            name: "Joanna",
            engine: "neural",
          },
          {
            ...Nualas.nuala11,
            name: "Salli",
            engine: "neural",
          },
          {
            ...Nualas.nuala13,
            name: "Ivy",
            engine: "neural",
            isChild: true,
          },
          {
            ...Nualas.nuala14,
            name: "Kendra",
            engine: "neural",
          },
          {
            ...Nualas.nuala16,
            name: "Kimberly",
            engine: "neural",
          },
          {
            ...Nualas.nuala8,
            name: "Matthew",
            engine: "neural",
          },
          {
            ...Nualas.nuala10,
            name: "Justin",
            engine: "neural",
            isChild: true,
          },
          {
            ...Nualas.nuala12,
            name: "Joey",
            engine: "neural",
          },
          {
            ...Nualas.nuala15,
            name: "Kevin",
            engine: "neural",
            isChild: true,
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala17,
            name: "Ruth",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala19,
            name: "Stephen",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala4,
            name: "Jenny",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala5,
            name: "Guy",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala9,
            name: "Ana",
            engine: "neural",
            provider: "azure",
            isChild: true,
          },
          {
            ...Nualas.nuala8,
            name: "Aria",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala7,
            name: "Davis",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala6,
            name: "Sara",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala5,
            name: "Tony",
            engine: "neural",
            provider: "azure",
          },
        ],
      },
      "en-GB": {
        label: "English, Britain",
        languageCode: "en-GB",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala2,
            name: "Sonia",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala7,
            name: "Ryan",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala9,
            name: "Libby",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala11,
            name: "Alfie",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala18,
            name: "Maisie",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
            isChild: true,
          },
          // Polly
          {
            ...Nualas.nuala20,
            name: "Amy",
            engine: "neural",
          },
          {
            ...Nualas.nuala21,
            name: "Emma",
            engine: "neural",
          },
          {
            ...Nualas.nuala4,
            name: "Brian",
            engine: "neural",
          },
          {
            ...Nualas.nuala1,
            name: "Arthur",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala6,
            name: "Noah",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala2,
            name: "Elliot",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala3,
            name: "Oliver",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala4,
            name: "Mia",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala5,
            name: "Thomas",
            engine: "neural",
            provider: "azure",
          },
        ],
      },
      "en-AU": {
        label: "English, Australia",
        languageCode: "en-AU",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala21,
            name: "Natasha",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala19,
            name: "William",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala18,
            name: "Olivia",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala7,
            name: "Nicole",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala5,
            name: "Russell",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "en-IN": {
        label: "English, India",
        languageCode: "en-IN",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala8,
            name: "Aarav",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala16,
            name: "Aashi",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala21,
            name: "Kajal",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala6,
            name: "Aditi",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala11,
            name: "Raveena",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "en-IE": {
        label: "English, Ireland",
        languageCode: "en-IE",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala6,
            name: "Emily",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala19,
            name: "Connor",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala20,
            name: "Niamh",
            engine: "neural",
            isNeuralOnly: true,
          },
        ],
      },
      "en-NZ": {
        label: "English, New Zealand",
        languageCode: "en-NZ",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala7,
            name: "Molly",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Mitchell",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala2,
            name: "Aria",
            engine: "neural",
            isNeuralOnly: true,
          },
        ],
      },
      "en-ZA": {
        label: "English, South Africa",
        languageCode: "en-ZA",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala9,
            name: "Leah",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala4,
            name: "Luke",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala16,
            name: "Ayanda",
            engine: "neural",
            isNeuralOnly: true,
          },
        ],
      },
      "en-GB-WLS": {
        label: "English, Wales",
        languageCode: "en-GB-WLS",
        voiceOptions: [
          {
            ...Nualas.nuala12,
            name: "Geraint",
            engine: "standard",
            legacy: true,
          },
        ],
      },
    },
    Code: "en",
    Tag: "en-US",
    characters: [],
    topicBlueprints: TopicTemplates.english,
    roleplayBlueprints: roleplayTemplates.english,
    botBlueprints: BotTemplates.english,
    BotTemplate:
      "! version = 1.0\r\n\r\n+ hello bot\r\n- Hello human.\r\n\r\n+ my name is *\r\n- <set name=<formal>>Nice to meet you, <get name>.\r\n\r\n+ (what is my name|who am i)\r\n- You're <get name>, right?\r\n\r\n+ *\r\n- I don't have a reply for that.\r\n- Try asking that a different way.",
  },
  french: {
    categoryTypesArray: ["Categories"],
    Voice: "Celine",
    AzureVoice: "Denise",
    skipAnswerMessage: ["Ne baisse pas les bras !"],
    correctAnswerMessage: ["Bravo !", "Sensationnel !"],
    incorrectAnswerMessage: ["Pas exactement !"],
    partiallyCorrectAnswerMessage: [
      "Bon effort !",
      "Bon travail !",
      "Bien joué !",
    ],
    Voices: {
      "fr-FR": {
        label: "French",
        languageCode: "fr-FR",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala21,
            name: "Denise",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala18,
            name: "Brigitte",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala16,
            name: "Celeste",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala19,
            name: "Henri",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Alain",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala14,
            name: "Claude",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala3,
            name: "Lea",
            engine: "neural",
          },
          {
            ...Nualas.nuala15,
            name: "Remi",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala2,
            name: "Celine",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala4,
            name: "Mathieu",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "fr-CA": {
        label: "French, Canada",
        languageCode: "fr-CA",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala11,
            name: "Sylvie",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala13,
            name: "Jean",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala14,
            name: "Gabrielle",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala10,
            name: "Liam",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala20,
            name: "Chantal",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "fr-BE": {
        label: "French, Belgium",
        languageCode: "fr-BE",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala9,
            name: "Charline",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala12,
            name: "Gerard",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala7,
            name: "Isabelle",
            engine: "neural",
            isNeuralOnly: true,
          },
        ],
      },
      "fr-CH": {
        label: "French, Switzerland",
        languageCode: "fr-CH",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala6,
            name: "Ariane",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala8,
            name: "Fabrice",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
        ],
      },
    },
    Code: "fr",
    Tag: "fr-FR",
    characters: [
      "à",
      "À",
      "â",
      "Â",
      "æ",
      "Æ",
      "è",
      "È",
      "é",
      "É",
      "ê",
      "Ê",
      "ë",
      "Ë",
      "î",
      "Î",
      "ï",
      "Ï",
      "ô",
      "Ô",
      "ù",
      "Ù",
      "û",
      "Û",
      "ü",
      "Ü",
      "ç",
      "Ç",
      "œ",
      "Œ",
    ],
    topicBlueprints: TopicTemplates.french,
    roleplayBlueprints: roleplayTemplates.french,
    botBlueprints: BotTemplates.french,
    fromScratchStarter: `// Voici les bases pour bien commencer
    
// Ceci est un déclencheur, indiqué par '+'. (devrait être en minuscule)
+ bonjour
// Ce sont des réponses, indiquées par '-'. (Vous pouvez en avoir autant que vous voulez par déclencheur)
- Salut
- Salut, comment vas tu?

// Voici un déclencheur interceptant, indiqué par un seul caractère générique '*'.
// Il sera utilisé lorsque le bot n'a pas trouvé de déclencheur correspondant
+ *
- Je suis désolé, je ne comprends pas.
- Pouvez-vous demander cela d'une manière différente.`,
    BotTemplate:
      "! version = 2.0\r\n\r\n+ bonjour bot\r\n- Bonjour humain.\r\n\r\n+ mon nom est *\r\n- <set name=<formal>>Ravi de vous rencontrer, <get nom>.\r\n\r\n+ (quel est mon nom|qui suis-je)\r\n- Vous \u00EAtes <get nom>, non?\r\n\r\n+ *\r\n- Je n'ai pas de r\u00E9ponse pour \u00E7a.\r\n- Essayez de demander cela d'une mani\u00E8re diff\u00E9rente.",
  },
  italian: {
    categoryTypesArray: ["Categories"],
    Voice: "Carla",
    skipAnswerMessage: ["Non arrenderti."],
    correctAnswerMessage: ["Perfetto!"],
    incorrectAnswerMessage: ["Non esattamente!"],
    partiallyCorrectAnswerMessage: ["Bene!"],
    Voices: {
      "it-IT": {
        label: "Italian",
        languageCode: "it-IT",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala5,
            name: "Giuseppe",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala3,
            name: "Elsa",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala9,
            name: "Isabella",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Diego",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala3,
            name: "Bianca",
            engine: "neural",
          },
          {
            ...Nualas.nuala12,
            name: "Adriano",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala2,
            name: "Carla",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala1,
            name: "Giorgio",
            engine: "standard",
            legacy: true,
          },
        ],
      },
    },
    Code: "it",
    Tag: "it-IT",
    characters: [
      "à",
      "À",
      "á",
      "Á",
      "è",
      "È",
      "é",
      "É",
      "ì",
      "Ì",
      "í",
      "Í",
      "ò",
      "Ò",
      "ó",
      "Ó",
      "ù",
      "Ù",
      "ú",
      "Ú",
    ],
    topicBlueprints: TopicTemplates.italian,
    roleplayBlueprints: roleplayTemplates.italian,
    botBlueprints: BotTemplates.italian,
    fromScratchStarter: `// Ecco le basi per iniziare
    
// Questo è un trigger, indicato da '+'. (dovrebbe essere in minuscolo)
+ ciao
// Queste sono risposte, indicate da '-'. (Puoi averne quanti ne vuoi per trigger)
- Ciao
- Ehi, come stai?

// Ecco un trigger catch all, indicato da un singolo carattere jolly '*'.
// Verrà utilizzato quando il bot non ha trovato un trigger corrispondente
+ *
- Mi dispiace, non capisco.
- Potresti chiederlo in un modo diverso.`,
    BotTemplate:
      "! versione = 1.0\r\n\r\n+ ciao bot\r\n- Ciao umano.\r\n\r\n+ il mio nome e *\r\n- <set nome=<formal>>piacere di conoscerti, <get nome>.\r\n\r\n+ (qual è il mio nome|chi sono)\r\n- Sei <get nome>, giusto?\r\n\r\n+ *\r\n- Non ho una risposta per questo.\r\n- Prova a chiederlo in un modo diverso.",
  },
  german: {
    categoryTypesArray: ["Categories"],
    Voice: "Vicki",
    AzureVoice: "Katja",
    skipAnswerMessage: ["Gib nicht auf."],
    correctAnswerMessage: ["Perfekt!"],
    incorrectAnswerMessage: ["Nicht genau!"],
    partiallyCorrectAnswerMessage: ["Gut!"],
    Voices: {
      "de-DE": {
        label: "German",
        languageCode: "de-DE",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala6,
            name: "Katja",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala11,
            name: "Amala",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala16,
            name: "Gisela",
            engine: "neural",
            isChild: true,
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala7,
            name: "Christoph",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala10,
            name: "Conrad",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala8,
            name: "Kasper",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala2,
            name: "Vicki",
            engine: "neural",
          },
          {
            ...Nualas.nuala19,
            name: "Daniel",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala3,
            name: "Marlene",
            engine: "standard",
            legacy: true,
          },
          {
            ...Nualas.nuala1,
            name: "Hans",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "de-AT": {
        label: "German, Austria",
        languageCode: "de-AT",
        voiceOptions: [
          {
            ...Nualas.nuala21,
            name: "Hannah",
            engine: "neural",
            isNeuralOnly: true,
          },
          // Azure
          {
            ...Nualas.nuala9,
            name: "Ingrid",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Jonas",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
        ],
      },
      "de-CH": {
        label: "German, Switzerland",
        languageCode: "de-CH",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala20,
            name: "Leni",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala5,
            name: "Jan",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
        ],
      },
    },
    Code: "de",
    Tag: "de-DE",
    characters: ["ä", "Ä", "ö", "Ö", "ü", "Ü", "ß"],
    topicBlueprints: TopicTemplates.german,
    roleplayBlueprints: roleplayTemplates.german,
    botBlueprints: BotTemplates.german,
    fromScratchStarter: `// Hier sind die Grundlagen für den Einstieg
    
// Dies ist ein Trigger, angezeigt durch '+'. (sollte klein geschrieben sein)
+ hallo
// Dies sind Antworten, die mit '-' gekennzeichnet sind. (Sie können so viele pro Trigger haben, wie Sie möchten)
- Hallo
- Hallo, wie geht es dir?

// Hier ist ein Catch-All-Trigger, der durch ein einzelnes Platzhalterzeichen ('*') angezeigt wird.
// Wird verwendet, wenn der Bot keinen passenden Trigger gefunden hat
+ *
- Es tut mir leid, ich verstehe nicht.
- Könnten Sie das anders fragen.`,
    BotTemplate:
      "! Version = 2.0\r\n\r\n+ hallo bot\r\n- Hallo Mensch.\r\n\r\n+ mein name ist *\r\n- <set Name=<formal>>Sch\u00F6n, Sie kennenzulernen, <get Name>.\r\n\r\n+ (Wie ist mein Name?|Wer bin ich?)\r\n- Du bist <get Name>, richtig?\r\n\r\n+ *\r\n- Ich habe keine Antwort daf\u00FCr.\r\n- Fragen Sie das mal anders.",
  },
  portuguese: {
    categoryTypesArray: ["Categories"],
    Voice: "Vitoria",
    skipAnswerMessage: ["Não desista."],
    correctAnswerMessage: ["Perfeito!"],
    incorrectAnswerMessage: ["não exatamente!"],
    partiallyCorrectAnswerMessage: ["Bom!"],
    Voices: {
      "pt-BR": {
        label: "Portuguese, Brazil",
        languageCode: "pt-BR",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala21,
            name: "Thalita",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala20,
            name: "Francisca",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Antonio",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala2,
            name: "Vitoria",
            engine: "neural",
          },
          {
            ...Nualas.nuala3,
            name: "Camila",
            engine: "neural",
          },
          {
            ...Nualas.nuala12,
            name: "Thiago",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala4,
            name: "Ricardo",
            engine: "standard",
            legacy: true,
          },
        ],
      },
      "pt-PT": {
        label: "Portuguese, Europe",
        languageCode: "pt-PT",
        voiceOptions: [
          // Azure
          {
            ...Nualas.nuala6,
            name: "Raquel",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          {
            ...Nualas.nuala19,
            name: "Duarte",
            engine: "neural",
            // isNeuralOnly: true,
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala13,
            name: "Ines",
            engine: "neural",
          },
          {
            ...Nualas.nuala15,
            name: "Cristiano",
            engine: "standard",
            legacy: true,
          },
        ],
      },
    },
    Code: "pt",
    Tag: "pt-BR",
    characters: [
      "ã",
      "Ã",
      "á",
      "Á",
      "â",
      "Â",
      "à",
      "À",
      "é",
      "É",
      "ê",
      "Ê",
      "í",
      "Í",
      "õ",
      "Õ",
      "ó",
      "Ó",
      "ô",
      "Ô",
      "ú",
      "Ú",
      "ü",
      "Ü",
      "ç",
      "Ç",
    ],
    topicBlueprints: TopicTemplates.portuguese,
    roleplayBlueprints: roleplayTemplates.portuguese,
    botBlueprints: BotTemplates.portuguese,
    fromScratchStarter: `// Aqui estão os princípios básicos para você começar
    
// Este é um gatilho, indicado por '+'. (deve estar em minúsculas)
+ olá
// Estas são respostas, indicadas por '-'. (Você pode ter quantos quiser por gatilho)
- Olá
- Olá, como vai?

// Aqui está um gatilho catch all, indicado por um único curinga '*'.
// Será usado quando o bot não encontrou um gatilho correspondente
+ *
Me desculpe, eu não entendo.
- Você poderia perguntar isso de uma maneira diferente.`,
    BotTemplate:
      "! vers\u00E3o = 2.0\r\n\r\n+ ol\u00E1 bot\r\n- Ol\u00E1 humano.\r\n\r\n+ meu nome \u00E9 *\r\n- <set nome=<formal>>Prazer em conhec\u00EA-lo, <get nome>.\r\n\r\n+ (qual \u00E9 o meu nome|quem sou eu?)\r\n- Voc\u00EA \u00E9 <get nome>, certo?\r\n\r\n+ *\r\n- Eu n\u00E3o tenho uma resposta para isso.\r\n- Tente perguntar isso de uma maneira diferente.",
  },
  irish: {
    categoryTypesArray: ["Categories"],
    Voice: null,
    Voices: {},
    Code: "ga",
    Tag: null,
    characters: ["á", "Á", "é", "É", "í", "Í", "ó", "Ó", "ú", "Ú"],
    topicBlueprints: TopicTemplates.irish,
    roleplayBlueprints: roleplayTemplates.irish,
    botBlueprints: BotTemplates.irish,
    fromScratchStarter: `// Aqui estão os princípios básicos para você começar
    
// Este é um gatilho, indicado por '+'. (deve estar em minúsculas)
+ olá
// Estas são respostas, indicadas por '-'. (Você pode ter quantos quiser por gatilho)
- Olá
- Olá, como vai?

// Aqui está um gatilho catch all, indicado por um único curinga '*'.
// Será usado quando o bot não encontrou um gatilho correspondente
+ *
Me desculpe, eu não entendo.
- Você poderia perguntar isso de uma maneira diferente.`,
    BotTemplate:
      "! vers\u00E3o = 2.0\r\n\r\n+ ol\u00E1 bot\r\n- Ol\u00E1 humano.\r\n\r\n+ meu nome \u00E9 *\r\n- <set nome=<formal>>Prazer em conhec\u00EA-lo, <get nome>.\r\n\r\n+ (qual \u00E9 o meu nome|quem sou eu?)\r\n- Voc\u00EA \u00E9 <get nome>, certo?\r\n\r\n+ *\r\n- Eu n\u00E3o tenho uma resposta para isso.\r\n- Tente perguntar isso de uma maneira diferente.",
  },
  chinese: {
    Voice: "Zhiyu",
    skipAnswerMessage: ["不要放弃！"],
    correctAnswerMessage: ["完美！"],
    incorrectAnswerMessage: ["不完全正确！"],
    partiallyCorrectAnswerMessage: ["好！"],
    Voices: {
      "cmn-CN": {
        label: "Chinese (Mandarin)",
        languageCode: "zh-CN",
        voiceOptions: [
          //Azure
          {
            ...Nualas.nuala6,
            name: "Yunyang",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala16,
            name: "Xiaoxiao",
            engine: ":DragonHDFlashLatestNeural",
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Xiaoshuang",
            engine: "neural",
            provider: "azure",
            isChild: true,
          },
          {
            ...Nualas.nuala21,
            name: "Yunxia",
            engine: ":DragonHDFlashLatestNeural",
            provider: "azure",
            isChild: true,
          },
          {
            ...Nualas.nuala19,
            name: "Yunxi",
            engine: "neural",
            provider: "azure",
          },
          // Polly
          {
            ...Nualas.nuala3,
            name: "Zhiyu",
            engine: "neural",
          },
        ],
      },
    },
    Code: "zh",
    Tag: "cmn-CN",
    characters: [],
    topicBlueprints: TopicTemplates.chinese,
    roleplayBlueprints: roleplayTemplates.chinese,
    botBlueprints: BotTemplates.chinese,
    fromScratchStarter: `// 以下是入门基础知识
    
// 这是一个触发器，用'+'表示。（应该是小写）
+ 你好
// 这些是回复，用'-'表示。（每个触发器可以有多个回复）
- 你好
- 你好，你好吗？

// 这是一个通用触发器，用单个通配符'*'表示。
// 当机器人没有找到匹配的触发器时将使用此触发器
+ *
- 抱歉，我不明白。
- 你能换个方式问吗？`,
    BotTemplate:
      "! version = 2.0\r\n\r\n+ 你好机器人\r\n- 你好人类。\r\n\r\n+ 我的名字是 *\r\n- <set name=<formal>>很高兴见到你，<get name>。\r\n\r\n+ (我的名字是什么|我是谁)\r\n- 你是<get name>，对吧？\r\n\r\n+ *\r\n- 我没有这个问题的答案。\r\n- 请尝试换个方式问。",
  },
  japanese: {
    Voice: "Nanami",
    skipAnswerMessage: ["あきらめないで！"],
    correctAnswerMessage: ["完璧！"],
    incorrectAnswerMessage: ["完全に正しくない！"],
    partiallyCorrectAnswerMessage: ["いいね！"],
    Voices: {
      "ja-JP": {
        label: "Japanese",
        languageCode: "ja-JP",
        voiceOptions: [
          //Azure
          {
            ...Nualas.nuala18,
            name: "Nanami",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala1,
            name: "Shiori",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala2,
            name: "Keita",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala3,
            name: "Mayu",
            engine: "neural",
            provider: "azure",
          },
          {
            ...Nualas.nuala17,
            name: "Aoi",
            engine: "neural",
            provider: "azure",
            isChild: true,
          },
          // Polly
          {
            ...Nualas.nuala6,
            name: "Takumi",
            engine: "neural",
          },
          {
            ...Nualas.nuala8,
            name: "Kazuha",
            engine: "neural",
            isNeuralOnly: true,
          },
          {
            ...Nualas.nuala9,
            name: "Tomoko",
            engine: "neural",
            isNeuralOnly: true,
          },
        ],
      },
    },
    Code: "ja",
    Tag: "ja-JP",
    characters: [],
    topicBlueprints: TopicTemplates.japanese,
    roleplayBlueprints: roleplayTemplates.japanese,
    botBlueprints: BotTemplates.japanese,
    fromScratchStarter: `// 以下は、開始するための基本です
    
// これは、'+'で示されるトリガーです。（小文字である必要があります）
+ こんにちは
// これらは、'-'で示される返信です。（トリガーごとにいくつでも返信を用意できます）
- こんにちは
- こんにちは、お元気ですか？

// これは、単一のワイルドカード'*'で示されるキャッチオールトリガーです。
// ボットが一致するトリガーを見つけられなかったときに使用されます
+ *
- すみません、わかりません。
- 別の方法で質問していただけますか？`,
    BotTemplate:
      "! version = 2.0\r\n\r\n+ こんにちはボット\r\n- こんにちは人間。\r\n\r\n+ 私の名前は *\r\n- <set name=<formal>>お会いできてうれしいです、<get name>。\r\n\r\n+ (私の名前は何ですか|私は誰ですか)\r\n- あなたは<get name>ですね？\r\n\r\n+ *\r\n- これに対する答えがありません。\r\n- 別の方法で質問してみてください。",
  },
};

const forLanguages = {
  spanish: {
    Code: "es",
    characters: [
      "¿",
      "¡",
      "á",
      "Á",
      "é",
      "É",
      "í",
      "Í",
      "ó",
      "Ó",
      "ú",
      "Ú",
      "ü",
      "Ü",
      "ñ",
      "Ñ",
    ],
  },
  english: {
    Code: "en",
    characters: [],
  },
  french: {
    Code: "fr",
    characters: [
      "à",
      "À",
      "â",
      "Â",
      "æ",
      "Æ",
      "è",
      "È",
      "é",
      "É",
      "ê",
      "Ê",
      "ë",
      "Ë",
      "î",
      "Î",
      "ï",
      "Ï",
      "ô",
      "Ô",
      "ù",
      "Ù",
      "û",
      "Û",
      "ü",
      "Ü",
      "ç",
      "Ç",
      "œ",
      "Œ",
    ],
  },
  italian: {
    Code: "it",
    characters: [
      "à",
      "À",
      "á",
      "Á",
      "è",
      "È",
      "é",
      "É",
      "ì",
      "Ì",
      "í",
      "Í",
      "ò",
      "Ò",
      "ó",
      "Ó",
      "ù",
      "Ù",
      "ú",
      "Ú",
    ],
  },
  german: {
    Code: "de",
    characters: ["ä", "Ä", "ö", "Ö", "ü", "Ü", "ß"],
  },
  portuguese: {
    Code: "pt",
    characters: [
      "ã",
      "Ã",
      "á",
      "Á",
      "â",
      "Â",
      "à",
      "À",
      "é",
      "É",
      "ê",
      "Ê",
      "í",
      "Í",
      "õ",
      "Õ",
      "ó",
      "Ó",
      "ô",
      "Ô",
      "ú",
      "Ú",
      "ü",
      "Ü",
      "ç",
      "Ç",
    ],
  },
  ukrainian: {
    Code: "uk",
    characters: [],
  },
  irish: {
    Code: "ga",
    characters: ["á", "Á", "é", "É", "í", "Í", "ó", "Ó", "ú", "Ú"],
  },
  arabic: {
    Code: "ar",
    characters: [],
  },
  chinese_simplified: {
    Code: "zh",
    characters: [],
  },
  chinese_traditional: {
    Code: "zh-TW",
    characters: [],
  },
  czech: {
    Code: "cs",
    characters: [],
  },
  danish: {
    Code: "da",
    characters: [],
  },
  dutch: {
    Code: "nl",
    characters: [],
  },
  filipino: {
    Code: "tl",
    characters: [],
  },
  greek: {
    Code: "el",
    characters: [],
  },
  hindi: {
    Code: "hi",
    characters: [],
  },
  hungarian: {
    Code: "hu",
    characters: [],
  },
  indonesian: {
    Code: "id",
    characters: [],
  },
  japanese: {
    Code: "ja",
    characters: [],
  },
  korean: {
    Code: "ko",
    characters: [],
  },
  malay: {
    Code: "ms",
    characters: [],
  },
  polish: {
    Code: "pl",
    characters: [],
  },
  punjabi: {
    Code: "pa",
    characters: [],
  },
  romanian: {
    Code: "ro",
    characters: [],
  },
  swahili: {
    Code: "sw",
    characters: [],
  },
  thai: {
    Code: "th",
    characters: [],
  },
  turkish: {
    Code: "tr",
    characters: [],
  },
  vietnamese: {
    Code: "vi",
    characters: [],
  },
};

const neuralVoices = [
  "Lupe",
  "Pedro",
  "Lucia",
  "Sergio",
  "Mia",
  "Andres",
  "Joanna",
  "Salli",
  "Ivy",
  "Kendra",
  "Kimberly",
  "Matthew",
  "Justin",
  "Joey",
  "Kevin",
  "Ruth",
  "Stephen",
  "Amy",
  "Emma",
  "Brian",
  "Arthur",
  "Olivia",
  "Lea",
  "Remi",
  "Gabrielle",
  "Liam",
  "Isabelle",
  "Bianca",
  "Adriano",
  "Vicki",
  "Daniel",
  "Vitoria",
  "Camila",
  "Thiago",
  "Ines",
  "Hannah",
  "Kajal",
  "Aria",
  "Ayanda",
  "Niamh",
  "Denise",
  "Brigitte",
  "Celeste",
  "Henri",
  "Alain",
  "Claude",
  "Sylvie",
  "Jean",
  "Charline",
  "Gerard",
  "Ariane",
  "Fabrice",
  "Katja",
  "Amala",
  "Gisela",
  "Christoph",
  "Conrad",
  "Kasper",
  "Ingrid",
  "Jonas",
  "Leni",
  "Jan",
  "Zhiyu",
  "Takumi",
  "Kazuha",
  "Tomoko",
];

const azureVoices = [
  "Denise",
  "Brigitte",
  "Celeste",
  "Henri",
  "Alain",
  "Claude",
  "Sylvie",
  "Jean",
  "Charline",
  "Gerard",
  "Ariane",
  "Fabrice",
  "Katja",
  "Amala",
  "Gisela",
  "Christoph",
  "Conrad",
  "Kasper",
  "Ingrid",
  "Jonas",
  "Leni",
  "Jan",
  "Paloma",
  "Alonso",
  "Marina",
  "Dalia",
  "Jorge",
  "Luciano",
  "Emily",
  "Connor",
  "Ava",
  "Andrew",
  "Jason",
  "Jane",
  "Sonia",
  "Ryan",
  "Libby",
  "Alfie",
  "Maisie",
  "Natasha",
  "William",
  "Aarav",
  "Aashi",
  "Molly",
  "Mitchell",
  "Leah",
  "Luke",
  "Giuseppe",
  "Elsa",
  "Isabella",
  "Diego",
  "Thalita",
  "Francisca",
  "Antonio",
  "Raquel",
  "Duarte",
  "Ximena",
  "Elvira",
  "Alvaro",
  "Yunyang",
  "Nanami",
  "Keita",
  "Xiaoxiao",
  "Xiaoshuang",
  "Yunxia",
  "Yunxi",
  "Shiori",
  "Keita",
  "Mayu",
  "Aoi",
  "Dario",
  "Vera",
  "Carlota",
  "Jenny",
  "Guy",
  "Ana",
  "Aria",
  "Davis",
  "Sara",
  "Tony",
  "Noah",
  "Elliot",
  "Oliver",
  "Mia",
  "Thomas",
];

// See utils/voices: a bare voice name identifies neither the voice nor its
// provider, so the language tree is the only source of truth for both.
const resolveVoice = (voiceName, options) =>
  resolveVoiceIn(languages, voiceName, options);

const cognitoConfig = {
  // Amazon Cognito Identity Pool ID
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  // Amazon Cognito Region
  region: process.env.REACT_APP_REGION,
  // Amazon Cognito User Pool ID
  userPoolId: process.env.REACT_APP_USERPOOL_ID,
  // Amazon Cognito Web Client ID
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
  mandatorySignIn: true,
};

const amplify = {
  aws_project_region: process.env.REACT_APP_REGION,
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
  aws_cognito_region: process.env.REACT_APP_REGION,
  aws_user_pools_id: process.env.REACT_APP_USERPOOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_OAUTH_DOMAIN,
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN,
    redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT,
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 10,
    passwordPolicyCharacters: [
      // "REQUIRES_LOWERCASE",
      // "REQUIRES_NUMBERS",
      // "REQUIRES_SYMBOLS",
      // "REQUIRES_UPPERCASE"
    ],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  Storage: {
    AWSS3: {
      bucket: `nualang-images-${process.env.REACT_APP_STAGE}`, //REQUIRED -  Amazon S3 bucket name
      region: process.env.REACT_APP_REGION, //OPTIONAL -  Amazon service region
    },
    customPrefix: {
      public: "",
      protected: "",
      private: "",
    },
  },
  Auth: {
    authenticationFlowType: "USER_PASSWORD_AUTH",
  },
};

const terms = {
  path: `${process.env.REACT_APP_SITE_URL}/terms`,
  lastUpdated: "2025-02-24",
  keyChanges: [
    "We reference and include Wayside Publishing's Terms and Privacy Policy within our own",
  ],
};

const internalDomains = [
  "@nualang.com",
  "@fathomtech.io",
  "@waysidepublishing.com",
  "@gsuite.waysidepublishing.com",
];

export const featureFlags = {
  classroomModes: {
    readWrite: true,
    challenge: true,
  },
};

const keysToRemove = [
  "lastAssignmentsFetch",
  "isCorrectResultOpen",
  "isIncorrectResultOpen",
  "isPartiallyCorrectResultOpen",
  "isStudentAnswerDrawerOpen",
  "nualang-is-sidebar-collapsed",
  "lastClickedExercise",
  "focusCourseSettings",
];

const config = {
  cognito: cognitoConfig,
  amplify,
  APP_URL: process.env.REACT_APP_URL,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  WAYSIDE_LEARNING_SITE_URL: process.env.REACT_APP_WAYSIDE_LEARNING_SITE_URL,
  // API
  API: process.env.REACT_APP_API,
  WS_API: process.env.REACT_APP_WS_API,
  FuzzySearchAPI: process.env.REACT_APP_FUZZYSEARCH_API,
  stage: process.env.REACT_APP_STAGE,
  region: process.env.REACT_APP_REGION,
  ImageURL: process.env.REACT_APP_IMAGE_URL_HANDLER,
  ImageBucket: process.env.REACT_APP_IMAGE_BUCKET,
  OldImageCreatorURL: process.env.REACT_APP_OLD_IMAGE_CREATOR_URL,
  AudioURL: process.env.REACT_APP_AUDIO_URL_HANDLER,
  AudioBucket: process.env.REACT_APP_AUDIO_BUCKET,
  AssetsURL: process.env.REACT_APP_ASSETS_URL_HANDLER,
  AssetsBucket: process.env.REACT_APP_ASSETS_BUCKET,
  fileSizeLimit: process.env.REACT_APP_FILE_SIZE_LIMIT,
  CHAT_GPT_API: process.env.REACT_APP_CHAT_GPT_API_KEY,
  ReactQueryCache: 1000 * 60 * 60 * 24, //24 hours
  languages,
  forLanguages,
  terms,
  neuralVoices,
  resolveVoice,
  azureVoices,
  VCHAT_API: process.env.REACT_APP_VCHAT_API,
  supportEmail: process.env.REACT_APP_NUALANG_SUPPORT_EMAIL,
  CANDOO_API_DOMAIN: process.env.REACT_APP_CANDOO_API_DOMAIN,
  CHAMELEON_API_KEY: process.env.REACT_APP_CHAMELEON_API_KEY,
  internalDomains,
  limits,
  keysToRemove,
};

export default {
  ...config,
};
